import { Component, Input, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ApiRegularWithdrawal, RegularWithdrawalFrequencies } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-rent-withdrawal-card',
  templateUrl: './rent-withdrawal-card.component.html',
  styleUrl: './rent-withdrawal-card.component.scss',
  standalone: false,
})

export class RentWithdrawalCardComponent implements OnInit {
  @Input({required: true}) public withdrawal!: ApiRegularWithdrawal;
  @Input({required: true}) public investmentType!: 'portfolio' | 'strategy';

  public nextExecutionDate = '-';

  public regularWithdrawalFrequencies = RegularWithdrawalFrequencies;
  public toggled = false;

  public constructor(
    private modalService: ModalService,
  ) {}

  public toggle(): void {
    this.toggled = !this.toggled
  }

  public ngOnInit(): void {
    const nextExecutionDate = dayjs(this.withdrawal.nextExecutionDate);
    if(this.withdrawal.validTo) {
      const validToDate = dayjs(this.withdrawal.validTo);
      this.nextExecutionDate = validToDate.isAfter(nextExecutionDate) ? nextExecutionDate.format('DD. MM. YYYY') : '-';
    } else if (this.withdrawal.nextExecutionDate) {
      this.nextExecutionDate = nextExecutionDate.format('DD. MM. YYYY');
    }
  }

  public openRegularWithdrawCancelModal(): void {
    this.modalService.openRegularWithdrawCancelModal({
      regularWithdrawalId: this.withdrawal.regularWithdrawalId,
      preloader: false,
      withdrawStrategyName: this.withdrawal.portfolioName,
      investmentType: this.investmentType
    });
  }
}
